/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockManageUserListResVo } from './AdminStockManageUserListResVo';
import {
    AdminStockManageUserListResVoFromJSON,
    AdminStockManageUserListResVoFromJSONTyped,
    AdminStockManageUserListResVoToJSON,
    AdminStockManageUserListResVoToJSONTyped,
} from './AdminStockManageUserListResVo';

/**
 * 
 * @export
 * @interface PageDataAdminStockManageUserListResVo
 */
export interface PageDataAdminStockManageUserListResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataAdminStockManageUserListResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataAdminStockManageUserListResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataAdminStockManageUserListResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<AdminStockManageUserListResVo>}
     * @memberof PageDataAdminStockManageUserListResVo
     */
    records?: Array<AdminStockManageUserListResVo>;
}

/**
 * Check if a given object implements the PageDataAdminStockManageUserListResVo interface.
 */
export function instanceOfPageDataAdminStockManageUserListResVo(value: object): value is PageDataAdminStockManageUserListResVo {
    return true;
}

export function PageDataAdminStockManageUserListResVoFromJSON(json: any): PageDataAdminStockManageUserListResVo {
    return PageDataAdminStockManageUserListResVoFromJSONTyped(json, false);
}

export function PageDataAdminStockManageUserListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataAdminStockManageUserListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdminStockManageUserListResVoFromJSON)),
    };
}

export function PageDataAdminStockManageUserListResVoToJSON(json: any): PageDataAdminStockManageUserListResVo {
    return PageDataAdminStockManageUserListResVoToJSONTyped(json, false);
}

export function PageDataAdminStockManageUserListResVoToJSONTyped(value?: PageDataAdminStockManageUserListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdminStockManageUserListResVoToJSON)),
    };
}

